import { http } from '@/app/lib/http/client'

export interface Department {
    id: number
    name: string
    description: string
    slug: string
    is_active: boolean
    created_at: string
    updated_at: string
}

export interface CreateDepartmentPayload {
    name: string
    description?: string
    is_active?: boolean
}

export interface UpdateDepartmentPayload {
    name?: string
    description?: string
}

import { ListParams } from '../types/pagination'

export const departmentService = {
    async getDepartments(params?: ListParams) {
        const response = await http.get('/departments', { params })
        return response.data
    },

    async getDepartment(id: number) {
        const response = await http.get(`/departments/${id}`)
        return response.data
    },

    async createDepartment(payload: CreateDepartmentPayload) {
        const response = await http.post('/departments', payload)
        return response.data
    },

    async updateDepartment(id: number, payload: UpdateDepartmentPayload) {
        const response = await http.put(`/departments/${id}`, payload)
        return response.data
    },

    /**
     * Cambia el estado is_active del departamento.
     * Si se omite `is_active` en el payload, el backend invierte el valor actual.
     * Si se provee explicitamente, establece ese valor exacto.
     */
    async updateStatus(id: number, isActive?: boolean) {
        const payload = isActive !== undefined ? { is_active: isActive } : {}
        const response = await http.patch(`/departments/${id}/status`, payload)
        return response.data
    },

    async deleteDepartment(id: number) {
        const response = await http.delete(`/departments/${id}`)
        return response.data
    },
}
